export default {"src":"/_next/static/media/PaymentIconCategoryActive.6d8747df.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};